import React from "react";
export const SearchBarMobile = () => {
  const onChangeData = () => {
    return;
  };
  const handleKeyDown = () => {
    return;
  };

  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      id="iconLeft1"
                      placeholder="Tên, mã, tài sản ..."
                    />
                    <div className="form-control-position">
                      <i className="mdi mdi-magnify"></i>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
